import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { GoogleOAuthProvider } from '@react-oauth/google';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import './scss/style.scss';

import { shopService } from './functions/shopApi';

import TopNavbar from './components/navbar';
import Footer from './components/footer';
import Home from './pages/Home';
import Register from './pages/Register';
import Register2 from './pages/Register2';
import Shop from './pages/Shop';
import Cart from './pages/Cart';
import Profile from './pages/Profile';
import RegisterMember from './pages/RegisterMember';
import Login from './pages/Login';
import MobileLogin from './pages/MobileLogin';
import Logout from './pages/Logout';
import NotFound from './pages/NotFound';
import Payment from './pages/Payment';
import UPayment from './pages/uPayment';
import PaymentDone from './pages/PaymentDone';
import UPaymentDone from './pages/uPaymentDone';
import ForgotPassword from './pages/ForgotPassword';
import EditRegistration from './pages/EditRegistration';
import GroupRegistrationDone from './pages/GroupRegistrationDone';
import GroupLogin from './pages/GroupLogin';


function App() {

  const TITLE = "Kuching Marathon - Together, let's run Cat City";

  const [login, setLogin] = useState(false);
  const [authToken, setAuthToken] = useState('');
  const [userID, setUserID] = useState('');
  const [userName, setUserName] = useState('');
  const [runner, setRunner] = useState(1);
  // shopping merchandise
  const [itemList, setItemList] = useState([]);

  const [category, setCategory] = useState(['42KM', '21KM', '10KM', '5KM']);
  const [size, setSize] = useState(['2XS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL']);
  const [marathonPrice, setMarathonPrice] = useState({
    '42KM': 100,
    '21KM': 80,
    '10KM': 65,
    '5KM': 45
  });
  const marathonLabel = {
    '42KM': 'Full Marathon',
    '21KM': 'Half Marathon',
    '10KM': '10 KM',
    '5KM': '5 KM'
  };
  const [marathonDetails, setMarathonDetails] = useState([
    {
      'type': '42.195KM',
      'desc': '18 years old and above as of the event day',
      'price': 100
    },
    {
      'type': '21KM',
      'desc': '16 years old and above as of the event day',
      'price': 80
    },
    {
      'type': '10KM',
      'desc': '15 years old and above as of the event day',
      'price': 65
    },
    {
      'type': '5KM',
      'desc': '7 years old and above as of the event day / below must be accompanied by parents or guardian who is participant of 21 years old or older.',
      'price': 45
    }
  ]);


  // Set the date where the t-shirt type change start to charge admin fee
  const [tshirtTypeChangeStartDate, setTshirtTypeChangeStartDate] = useState("2026-05-01 00:00:00");

  // item selected in cart
  const [runnerList, setRunnerList] = useState([]);
  const [selectedList, setSelectedList] = useState([]);
  const [total, setTotal] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [adminFee, setAdminFee] = useState(20);
  const [deliveryFee, setDeliveryFee] = useState(20);
  const marathonName = '2026';
  const marathonStartDate = '27 September 2026'
  const sst = 0.08;

  const [testAddress, setTestAddress] = useState(["FORNEUMANUAL"]);
  const [testAcc, setTestAcc] = useState([
    // 'DNOQX5KX',
    // 'J4C2W7HP',
    // '00000001'
  ]);


  // update the prices of the run based of the different date
  useEffect(() => {
    let today = new Date();
    let superEarlyDate = new Date('2025-11-26 00:00:00');
    let earlyDate = new Date('2026-05-14 00:00:00');
    let normalDate = new Date('2026-07-12 00:00:00');
    let lateDate = new Date('2026-09-29 00:00:00');

    let newMarathonDetails = [...marathonDetails];

    let newPrice = {
      '42KM': 0,
      '21KM': 0,
      '10KM': 0,
      '5KM': 0
    };

    if (today >= superEarlyDate && today < earlyDate) {
      newPrice = {
        '42KM': 130,
        '21KM': 110,
        '10KM': 80,
        '5KM': 60
      };
    } else if (today >= earlyDate && today < normalDate) {
      newPrice = {
        '42KM': 150,
        '21KM': 130,
        '10KM': 80,
        '5KM': 60
      };
    } else if (today >= normalDate && today < lateDate) {
      newPrice = {
        '42KM': 160,
        '21KM': 140,
        '10KM': 80,
        '5KM': 60
      };
    } else {
      newPrice = {
        '42KM': 0,
        '21KM': 0,
        '10KM': 0,
        '5KM': 0
      };
    }

    var index = 0;
    for (var key in newPrice) {
      newMarathonDetails[index++].price = newPrice[key];
    }

    // shopService.getMerchandiseInfo()
    //         .then((response) => {

    //             // console.log(response);

    //             let merchandise = response.body.merchandise;
    //             let newMerchandise = [];

    //             merchandise.map((values, index) => {
    //                 let image = JSON.parse(values.imageURL);
    //                 let item = {
    //                     id : values.autoID,
    //                     name : values.product_name,
    //                     image1 : image[0],
    //                     price : parseFloat(values.price),
    //                     description : values.description
    //                 }
    //                 newMerchandise.push(item);
    //             });

    //             // console.log(newMerchandise);
    //             setItemList(newMerchandise);

    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         })


    setMarathonPrice(newPrice);
    setMarathonDetails(newMarathonDetails);

  }, [login]);

  useEffect(() => {
    const storedRunnerList = localStorage.getItem('runnerList');
    if (storedRunnerList === '' || storedRunnerList === null) {
      setRunnerList(JSON.parse(storedRunnerList))
    }
  }, [runnerList]);




  return (

    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>

      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <Router basename={'/register'}>

        <div className="App d-flex flex-column min-vh-100">

          {/* <Router> */}
          <TopNavbar
            login={login}
            userName={userName}
            selectedList={selectedList}
          />

          <Container className="flex-grow-1">

            <Routes>
              <Route path="/Home" element={<Home />} />
              <Route path="/RegisterMember" element={
                <RegisterMember
                  userID={userID}
                  setUserID={setUserID}
                  login={login}
                  setLogin={setLogin}
                  setUserName={setUserName}
                />
              }
              />
              <Route path="/Register" element={
                <Register
                  runner={runner}
                  setRunner={setRunner}
                  setUserID={setUserID}
                  setUserName={setUserName}
                  login={login}
                  setLogin={setLogin}
                  authToken={authToken}
                  setAuthToken={setAuthToken}
                  marathonDetails={marathonDetails}
                  marathonStartDate={marathonStartDate}
                />
              }
              />
              <Route path="/Register/2" element={
                <Register2
                  runner={runner}
                  runnerList={runnerList}
                  setRunnerList={setRunnerList}
                  marathonPrice={marathonPrice}
                  marathonLabel={marathonLabel}
                  userID={userID}
                  setUserID={setUserID}
                  setUserName={setUserName}
                  login={login}
                  setLogin={setLogin}
                  authToken={authToken}
                  setAuthToken={setAuthToken}
                  size={size}
                  sst={sst}
                  tshirtTypeChangeStartDate={tshirtTypeChangeStartDate}
                  testAcc={testAcc}
                />
              }
              />
              <Route path="/EditRegistration" element={
                <EditRegistration
                  runner={runner}
                  runnerList={runnerList}
                  setRunnerList={setRunnerList}
                  marathonPrice={marathonPrice}
                  marathonLabel={marathonLabel}
                  userID={userID}
                  setUserID={setUserID}
                  setUserName={setUserName}
                  login={login}
                  setLogin={setLogin}
                  authToken={authToken}
                  setAuthToken={setAuthToken}
                  adminFee={adminFee}
                  category={category}
                  size={size}
                  deliveryFee={deliveryFee}
                  sst={sst}
                  tshirtTypeChangeStartDate={tshirtTypeChangeStartDate}
                  testAcc={testAcc}
                />
              }
              />
              <Route path="/Shop" element={
                <Shop
                  itemList={itemList}
                  setItemList={setItemList}
                  selectedList={selectedList}
                  setSelectedList={setSelectedList}
                  total={total}
                  setTotal={setTotal}
                  discount={discount}
                  setDiscount={setDiscount}
                  setUserID={setUserID}
                  setUserName={setUserName}
                  login={login}
                  setLogin={setLogin}
                  authToken={authToken}
                  setAuthToken={setAuthToken}
                  deliveryFee={deliveryFee}
                />}
              />
              <Route path="/Profile" element={
                <Profile
                  login={login}
                  setLogin={setLogin}
                  userID={userID}
                  setUserID={setUserID}
                  setUserName={setUserName}
                  authToken={authToken}
                  setAuthToken={setAuthToken}
                  marathonName={marathonName}
                />}
              />
              <Route path="/Profile/:tab" element={
                <Profile
                  login={login}
                  setLogin={setLogin}
                  userID={userID}
                  setUserID={setUserID}
                  setUserName={setUserName}
                  authToken={authToken}
                  setAuthToken={setAuthToken}
                  marathonName={marathonName}
                />}
              />
              <Route path="/Cart" element={
                <Cart
                  login={login}
                  setLogin={setLogin}
                  userID={userID}
                  setUserID={setUserID}
                  setUserName={setUserName}
                  authToken={authToken}
                  setAuthToken={setAuthToken}
                  itemList={itemList}
                  setItemList={setItemList}
                  selectedList={selectedList}
                  setSelectedList={setSelectedList}
                  runnerList={runnerList}
                  setRunnerList={setRunnerList}
                  marathonLabel={marathonLabel}
                  marathonPrice={marathonPrice}
                  total={total}
                  setTotal={setTotal}
                  discount={discount}
                  setDiscount={setDiscount}
                  deliveryFee={deliveryFee}
                  adminFee={adminFee}
                  testAddress={testAddress}
                  sst={sst}
                />}
              />
              <Route path="/" element={
                <Login
                  login={login}
                  setLogin={setLogin}
                  userID={userID}
                  setUserID={setUserID}
                  userName={userName}
                  setUserName={setUserName}
                  authToken={authToken}
                  setAuthToken={setAuthToken}
                  marathonStartDate={marathonStartDate}
                />}
              />
              <Route path="/Login" element={
                <Login
                  login={login}
                  setLogin={setLogin}
                  userID={userID}
                  setUserID={setUserID}
                  userName={userName}
                  setUserName={setUserName}
                  authToken={authToken}
                  setAuthToken={setAuthToken}
                />}
              />
              <Route path="/GroupLogin" element={
                <GroupLogin

                />}
              />
              <Route path="/MobileLogin" element={
                <MobileLogin
                  login={login}
                  setLogin={setLogin}
                  userID={userID}
                  setUserID={setUserID}
                  userName={userName}
                  setUserName={setUserName}
                  authToken={authToken}
                  setAuthToken={setAuthToken}
                />}
              />
              <Route path="/Logout" element={
                <Logout
                  login={login}
                  setLogin={setLogin}
                  userID={userID}
                  setUserID={setUserID}
                  userName={userName}
                  setUserName={setUserName}
                  setAuthToken={setAuthToken}
                />
              } />
              <Route path="/Payment" element={
                <Payment
                  itemList={itemList}
                  marathonPrice={marathonPrice}
                  marathonLabel={marathonLabel}
                  userID={userID}
                  setUserID={setUserID}
                  setUserName={setUserName}
                  login={login}
                  setLogin={setLogin}
                  authToken={authToken}
                  setAuthToken={setAuthToken}
                  deliveryFee={deliveryFee}
                  sst={sst}
                />}
              />
              <Route path="/UPayment" element={
                <UPayment
                  itemList={itemList}
                  marathonPrice={marathonPrice}
                  marathonLabel={marathonLabel}
                  userID={userID}
                  setUserID={setUserID}
                  setUserName={setUserName}
                  login={login}
                  setLogin={setLogin}
                  authToken={authToken}
                  setAuthToken={setAuthToken}
                />}
              />
              <Route path="/PaymentDone/:paymentID" element={
                <PaymentDone
                  itemList={itemList}
                  marathonPrice={marathonPrice}
                  marathonLabel={marathonLabel}
                  userID={userID}
                  setUserID={setUserID}
                  setUserName={setUserName}
                  login={login}
                  setLogin={setLogin}
                  authToken={authToken}
                  setAuthToken={setAuthToken}
                />}
              />
              <Route path="/UPaymentDone/:paymentID" element={
                <UPaymentDone
                  itemList={itemList}
                  marathonPrice={marathonPrice}
                  marathonLabel={marathonLabel}
                  userID={userID}
                  setUserID={setUserID}
                  setUserName={setUserName}
                  login={login}
                  setLogin={setLogin}
                  authToken={authToken}
                  setAuthToken={setAuthToken}
                />}
              />
              <Route path="/GroupRegistrationDone/:groupCode" element={
                <GroupRegistrationDone
                  userID={userID}
                  setUserID={setUserID}
                  userName={userName}
                  setUserName={setUserName}
                  login={login}
                  setLogin={setLogin}
                  authToken={authToken}
                  setAuthToken={setAuthToken}
                />
              }
              />
              <Route path="/ForgotPassword" element={<ForgotPassword />} />
              <Route path='*' element={<NotFound />} />
            </Routes>

          </Container>

          <Footer />

        </div>

      </Router>

    </GoogleOAuthProvider>

  );

}

export default App;